"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.videosMetadataSelector = exports.videoMetadataSelector = exports.imagesMetadataSelector = exports.imageMetadataSelector = exports.videoMetadataForItemSelector = exports.imageMetadataForItemSelector = exports.videoSelector = exports.imageSelector = exports.selectedImageSelector = exports.selectedMediaSelector = exports.selectedMediaSizedImages = exports.selectedMediaFullImages = exports.selectedMediaIdSelector = exports.selectedMediaForItem = exports.fetchImage = exports.clearMetadata = exports.setMetadata = exports.setSelectedVideo = exports.pause = exports.play = exports.setBrokenImage = exports.clearImages = exports.getImageFailure = exports.getImageSuccess = exports.getImage = exports.setSelectedMediaId = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var apiService_1 = __importDefault(require("@common/services/apiService"));
var initialState = {
    byId: {},
    allIds: [],
};
var medias = (0, toolkit_1.createSlice)({
    name: 'medias',
    initialState: initialState,
    reducers: {
        setSelectedMediaId: function (state, _a) {
            var payload = _a.payload;
            var adId = payload.adId, selectedMediaId = payload.selectedMediaId;
            state.byId[adId].selectedMediaId = selectedMediaId;
        },
        getImage: function (state, _a) {
            var payload = _a.payload;
            var adId = payload.adId, imageId = payload.imageId, imageType = payload.imageType;
            var image = { id: imageId, status: 'loading', type: imageType };
            if (imageType === 'sizedImage') {
                state.byId[adId].sizedImages.push(image);
            }
            else {
                state.byId[adId].fullImages.push(image);
            }
        },
        getImageSuccess: function (state, _a) {
            var payload = _a.payload;
            var adId = payload.adId, imageId = payload.imageId, imageType = payload.imageType, objectURL = payload.objectURL;
            if (imageType === 'sizedImage') {
                var sizedImages = state.byId[adId].sizedImages;
                var index = sizedImages.findIndex(function (image) { return image.id === imageId; });
                sizedImages[index] = __assign(__assign({}, sizedImages[index]), { status: 'succeeded', objectURL: objectURL });
            }
            else {
                var fullImages = state.byId[adId].fullImages;
                var index = fullImages.findIndex(function (image) { return image.id === imageId; });
                fullImages[index] = __assign(__assign({}, fullImages[index]), { status: 'succeeded', objectURL: objectURL });
            }
        },
        getImageFailure: function (state, _a) {
            var payload = _a.payload;
            var adId = payload.adId, imageId = payload.imageId, imageType = payload.imageType;
            if (imageType === 'sizedImage') {
                var sizedImages = state.byId[adId].sizedImages;
                var index = sizedImages.findIndex(function (image) { return image.id === imageId; });
                sizedImages[index] = __assign(__assign({}, sizedImages[index]), { status: 'failed', type: imageType });
            }
            else {
                var fullImages = state.byId[adId].fullImages;
                var index = fullImages.findIndex(function (image) { return image.id === imageId; });
                fullImages[index] = __assign(__assign({}, fullImages[index]), { status: 'failed' });
            }
        },
        setBrokenImage: function (state, _a) {
            var payload = _a.payload;
            var adId = payload.adId, imageId = payload.imageId, imageType = payload.imageType;
            var image = { id: imageId, status: 'failed', type: imageType };
            if (imageType === 'sizedImage') {
                var sizedImages = state.byId[adId].sizedImages;
                sizedImages.push(image);
            }
            else {
                var fullImages = state.byId[adId].fullImages;
                fullImages.push(image);
            }
        },
        clearImages: function (state, _a) {
            var e_1, _b;
            var payload = _a.payload;
            var adId = payload.adId;
            var _c = state.byId[adId], sizedImages = _c.sizedImages, fullImages = _c.fullImages;
            if (sizedImages && fullImages) {
                try {
                    for (var _d = __values(__spreadArray(__spreadArray([], __read(sizedImages), false), __read(fullImages), false)), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var image = _e.value;
                        var objectURL = image === null || image === void 0 ? void 0 : image.objectURL;
                        objectURL && URL.revokeObjectURL(objectURL);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                state.byId[adId].sizedImages = [];
                state.byId[adId].fullImages = [];
            }
        },
        play: function (state, _a) {
            var payload = _a.payload;
            var adId = payload.adId;
            var videoId = state.byId[adId].selectedMediaId;
            var videos = state.byId[adId].videos;
            var index = videos.findIndex(function (image) { return image.id === videoId; });
            videos[index].isPlaying = true;
        },
        pause: function (state, _a) {
            var payload = _a.payload;
            var adId = payload.adId;
            var videoId = state.byId[adId].selectedMediaId;
            var videos = state.byId[adId].videos;
            var index = videos.findIndex(function (image) { return image.id === videoId; });
            videos[index].isPlaying = false;
        },
        setSelectedVideo: function (state, _a) {
            var payload = _a.payload;
            var adId = payload.adId, id = payload.id;
            state.byId[adId].selectedMediaId = id;
        },
        setMetadata: function (state, _a) {
            var _b, _c;
            var payload = _a.payload;
            var adId = payload.adId, videosMetadata = payload.videosMetadata, imagesMetadata = payload.imagesMetadata;
            var getId = function () {
                var _a;
                var selectedImageId = (_a = state.byId[adId]) === null || _a === void 0 ? void 0 : _a.selectedMediaId;
                if (selectedImageId) {
                    return selectedImageId;
                }
                if (imagesMetadata.length > 0) {
                    return imagesMetadata[0].id;
                }
                if (videosMetadata.length > 0) {
                    return videosMetadata[0].id;
                }
                return 0;
            };
            var id = getId();
            var videos = videosMetadata.map(function (metadata) { return ({ id: metadata.id, isPlaying: false, type: 'video' }); });
            state.byId[adId] = {
                adId: adId,
                selectedMediaId: id,
                sizedImages: ((_b = state.byId[adId]) === null || _b === void 0 ? void 0 : _b.sizedImages) ? state.byId[adId].sizedImages : [],
                fullImages: ((_c = state.byId[adId]) === null || _c === void 0 ? void 0 : _c.fullImages) ? state.byId[adId].fullImages : [],
                videos: videos,
                imagesMetadata: imagesMetadata,
                videosMetadata: videosMetadata,
            };
        },
        clearMetadata: function (state, _a) {
            var payload = _a.payload;
            var adId = payload.adId;
            delete state.byId[adId];
        },
    },
});
exports.setSelectedMediaId = (_a = medias.actions, _a.setSelectedMediaId), exports.getImage = _a.getImage, exports.getImageSuccess = _a.getImageSuccess, exports.getImageFailure = _a.getImageFailure, exports.clearImages = _a.clearImages, exports.setBrokenImage = _a.setBrokenImage, exports.play = _a.play, exports.pause = _a.pause, exports.setSelectedVideo = _a.setSelectedVideo, exports.setMetadata = _a.setMetadata, exports.clearMetadata = _a.clearMetadata;
function fetchImage(adId, imageId, requestUrl, imageType) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var data, blob, objectURL, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch((0, exports.getImage)({ adId: adId, imageId: imageId, imageType: imageType }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiService_1.default.getImage({ imageRequestUrl: requestUrl })];
                case 2:
                    data = (_a.sent()).data;
                    blob = new Blob([data], { type: 'image/jpeg' });
                    objectURL = URL.createObjectURL(blob);
                    dispatch((0, exports.getImageSuccess)({ adId: adId, imageId: imageId, imageType: imageType, objectURL: objectURL }));
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    dispatch((0, exports.getImageFailure)({ adId: adId, imageId: imageId, imageType: imageType }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
exports.fetchImage = fetchImage;
exports.default = medias.reducer;
var selectedMediaForItem = function (_a, adId) {
    var medias = _a.medias;
    return medias.byId[adId];
};
exports.selectedMediaForItem = selectedMediaForItem;
var selectedMediaIdSelector = function (_a, adId) {
    var medias = _a.medias;
    var media = medias.byId[adId];
    return media ? media.selectedMediaId : 0;
};
exports.selectedMediaIdSelector = selectedMediaIdSelector;
exports.selectedMediaFullImages = (0, toolkit_1.createSelector)([exports.selectedMediaForItem], function (media) { return (media === null || media === void 0 ? void 0 : media.fullImages) || []; });
exports.selectedMediaSizedImages = (0, toolkit_1.createSelector)([exports.selectedMediaForItem], function (media) { return (media === null || media === void 0 ? void 0 : media.sizedImages) || []; });
var selectedMediaSelector = function (_a, adId) {
    var medias = _a.medias;
    var media = medias.byId[adId];
    if (media) {
        var selectedMediaId_1 = media.selectedMediaId, sizedImages = media.sizedImages, fullImages = media.fullImages, videos = media.videos;
        return __spreadArray(__spreadArray(__spreadArray([], __read(fullImages), false), __read(sizedImages), false), __read(videos), false).find(function (image) { return image.id === selectedMediaId_1; });
    }
};
exports.selectedMediaSelector = selectedMediaSelector;
var selectedImageSelector = function (_a, adId) {
    var medias = _a.medias;
    var media = medias.byId[adId];
    if (media) {
        var selectedMediaId_2 = media.selectedMediaId, sizedImages = media.sizedImages, fullImages = media.fullImages;
        return __spreadArray(__spreadArray([], __read(fullImages), false), __read(sizedImages), false).find(function (image) { return image.id === selectedMediaId_2; });
    }
};
exports.selectedImageSelector = selectedImageSelector;
var imageSelector = function (_a, adId, imageId, type) {
    var medias = _a.medias;
    var media = medias.byId[adId];
    if (media) {
        var sizedImages = media.sizedImages, fullImages = media.fullImages;
        var image = type === 'fullImage' ? fullImages.find(function (image) { return image.id === imageId; }) : sizedImages.find(function (image) { return image.id === imageId; });
        return image;
    }
};
exports.imageSelector = imageSelector;
var videoSelector = function (_a, adId, videoId) {
    var _b;
    var medias = _a.medias;
    var media = medias.byId[adId];
    return (_b = media === null || media === void 0 ? void 0 : media.videos) === null || _b === void 0 ? void 0 : _b.find(function (video) { return video.id === videoId; });
};
exports.videoSelector = videoSelector;
var imageMetadataForItemSelector = function (_a, adId) {
    var medias = _a.medias;
    return medias.byId[adId].imagesMetadata;
};
exports.imageMetadataForItemSelector = imageMetadataForItemSelector;
var videoMetadataForItemSelector = function (_a, adId) {
    var medias = _a.medias;
    return medias.byId[adId].videosMetadata;
};
exports.videoMetadataForItemSelector = videoMetadataForItemSelector;
var imageMetadataSelector = function (_a, adId, imageId) {
    var _b;
    var medias = _a.medias;
    var media = medias.byId[adId];
    return (_b = media === null || media === void 0 ? void 0 : media.imagesMetadata) === null || _b === void 0 ? void 0 : _b.find(function (image) { return image.id === imageId; });
};
exports.imageMetadataSelector = imageMetadataSelector;
var imagesMetadataSelector = function (_a, adId) {
    var medias = _a.medias;
    var media = medias.byId[adId];
    return media ? media.imagesMetadata : [];
};
exports.imagesMetadataSelector = imagesMetadataSelector;
var videoMetadataSelector = function (_a, adId, videoId) {
    var _b;
    var medias = _a.medias;
    var media = medias.byId[adId];
    return (_b = media === null || media === void 0 ? void 0 : media.videosMetadata) === null || _b === void 0 ? void 0 : _b.find(function (video) { return video.id === videoId; });
};
exports.videoMetadataSelector = videoMetadataSelector;
var videosMetadataSelector = function (_a, adId) {
    var medias = _a.medias;
    var media = medias.byId[adId];
    return media ? media.videosMetadata : [];
};
exports.videosMetadataSelector = videosMetadataSelector;
